import React, { Component } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import EditQuestionTypeForm from '../components/EditQuestionTypeForm';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import PlainPanel from '../components/PlainPanel';
import config from '../config';
import qs from 'qs';
import { Link } from 'react-router-dom';

import './EditQuestionType.css';

class EditQuestionType extends Component {
    constructor(props) {
        super(props);

        this.state = { questiontype: { description: '', enabled: false } };
    }

    componentDidMount() {
        this.loadQuestionTypeFromServer();
    }

    loadQuestionTypeFromServer() {
        const { questiontypeID } = this.props.match.params;

        var self = this;
        axios
            .get(`${config.baseURL}/questiontypes/${questiontypeID}`, {})
            .then(function(response) {
                self.setState({ questiontype: response.data.questionType });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render() {
        const { t } = this.props;
        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;
        document.title = `MySign Digital Screen Solutions | ${t(
            'EditQuestionType.title'
        )}`;

        return (
            <div className="EditQuestionType">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('EditQuestionType.title')}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-info" />{' '}
                                        <Link to={`/qanda`}>
                                            {t('QAndA.title')}
                                        </Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-list" />{' '}
                                        <Link to={`/qanda/questiontypes`}>
                                            {t('QuestionTypes.title')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fas fa-pencil-alt" />{' '}
                                        {t('EditQuestionType.title')}
                                    </li>
                                </ol>

                                <PlainPanel>
                                    <EditQuestionTypeForm
                                        questiontype={this.state.questiontype}
                                    />
                                </PlainPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(EditQuestionType);
